/**
 * Focal theme: custom JavaScript.
 * (The original developer documentation comment was removed from this file; it is in the Focal theme docs.)
 *
 * ETHIQUE: Product card hover video
 * On desktop, when the mouse is over a product card, the first video of that product plays
 * on top of the image (muted, looping). Nothing loads until the card is hovered.
 * Products without a video are unaffected. Touch devices are skipped.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var cache = {};

  function getVideoUrl(path) {
    if (cache[path]) return cache[path];

    cache[path] = fetch(path + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.media) return null;

        var video = null;
        for (var i = 0; i < product.media.length; i++) {
          if (product.media[i].media_type === 'video') { video = product.media[i]; break; }
        }
        if (!video || !video.sources) return null;

        var mp4s = video.sources.filter(function (s) {
          return s.format === 'mp4' || (s.mime_type || '').indexOf('mp4') > -1;
        });
        if (!mp4s.length) return null;

        mp4s.sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
        var pick = mp4s[0];
        for (var j = 0; j < mp4s.length; j++) {
          if ((mp4s[j].height || 0) <= 720) pick = mp4s[j];
        }
        return pick.url;
      })
      .catch(function () { return null; });

    return cache[path];
  }

  function onEnter(card) {
    if (card.__ethiqueHover) return;
    card.__ethiqueHover = true;

    var link = card.querySelector('.product-item__aspect-ratio');
    if (!link || !link.pathname) return;

    getVideoUrl(link.pathname).then(function (url) {
      if (!url || !card.__ethiqueHover) return;

      var video = link.querySelector('.ethique-hover-video');
      if (!video) {
        video = document.createElement('video');
        video.className = 'ethique-hover-video';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        video.src = url;
        video.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s ease;z-index:1;pointer-events:none;';
        video.addEventListener('playing', function () {
          if (card.__ethiqueHover) video.style.opacity = '1';
        });
        link.appendChild(video);
      }

      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  }

  function onLeave(card) {
    card.__ethiqueHover = false;
    var video = card.querySelector('.ethique-hover-video');
    if (!video) return;
    video.pause();
    video.style.opacity = '0';
    try { video.currentTime = 0; } catch (e) {}
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest ? event.target.closest('product-item') : null;
    if (card) onEnter(card);
  });

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest ? event.target.closest('product-item') : null;
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
    onLeave(card);
  });
})();
